if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.addToCartFunction();
      }
    
      addToCartFunction() {
        const addToCartBtns = this.querySelectorAll('.add-to-cart-btn');
        addToCartBtns.forEach(btn => {
          btn.addEventListener('click', this.onBtnClick.bind(this));
        })
      }
    
      onBtnClick(e) {
        e.preventDefault();
        const thisBtn = e.target;
        this.updateCart(thisBtn);
      }
    
      updateCart(thisBtn) {
        const cart = document.querySelector('cart-drawer');
        const form = thisBtn.closest('.product-form #product-form');
    
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(form);
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
    
        // Start loading
        thisBtn.classList.add('loading');
      
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          cart.renderContents(response);
          cart.openCloseCart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    
          // End loading
          thisBtn.classList.remove('loading');

          // Recreate upsell slider
          const cartUpsell = document.querySelector('.cart-upsell');
          cartUpsell.createSlider();
        });
      }
    }
  );
}